import React from 'react'

type Props = {}

export default function MostPopularHeader({}: Props) {
  return (
    <div
      className={
        'text-color-gray5 text-xs-bold w-96 rounded-t-xl bg-bult-800 pt-1 pb-0 text-center'
      }
    >
      MOST POPULAR 🔥
    </div>
  )
}
